import { COLORS } from '../../../../constants';

const styles = theme => {
  const minMd = theme.breakpoints.up('md');

  return {
    cardHeaderRoot: {
      backgroundColor: COLORS.GREY_DARK,
    },
    cardHeaderTitle: {
      color: COLORS.WHITE,
      textAlign: 'center',
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    formGroup: {
      marginTop: 20,
      [minMd]: {
        marginTop: 30,
      },
      '&:first-child': {
        marginTop: 0,
      },
      // Prevent mobile field error text from overlapping with checkbox
      '& #mobile-phone-text-field-helper-text': {
        position: 'static',
      },
      // Prevent phone number field error text from overlapping with input field
      '& #personal-phone-text-field-helper-text': {
        display: 'contents',
      },
    },
    notificationDisclosure: {
      marginTop: 24,
      fontSize: '0.875rem',
      display: 'flex',
      lineHeight: 1.58,
      '& > div': {
        marginRight: 5,
      },
    },
    hidden: {
      display: 'none',
    },
    selectFormGroup: {
      '& .MuiFormControl-root': {
        width: '100%',
      },
      '& .MuiFormControlLabel-label': {
        flexGrow: 1,
        marginTop: 4,
        fontSize: '0.875rem',
      },
    },
  };
};

export default styles;
